import { render, staticRenderFns } from "./performance_set.vue?vue&type=template&id=76b38468&scoped=true"
import script from "./performance_set.vue?vue&type=script&lang=js"
export * from "./performance_set.vue?vue&type=script&lang=js"
import style0 from "./performance_set.vue?vue&type=style&index=0&id=76b38468&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b38468",
  null
  
)

export default component.exports